<template>
	<div class="con-list">
		<van-field v-if="!isDetail" class="select" is-link readonly clickable v-model="deptIdName" prop="deptId" required  label="部门" placeholder="请输入部门名称搜索"
			@click="selectInfo('请输入部门名称搜索','dept')" :rules="[{ required: true, message: '部门不能为空', trigger: 'onChange' }]"/>
		<van-field v-else disabled required v-model="data.deptDescr"  label="部门"/>

		<van-field v-if="!isDetail" class="select" is-link readonly clickable v-model="supervisorIdName" prop="supervisorId" required  label="直接上级" placeholder="请输入直接上级名字搜索"
			@click="selectInfo('请输入直接上级名字搜索','person')" :rules="[{ required: true, message: '直接上级不能为空', trigger: 'onChange' }]"/>
		<van-field v-else disabled required v-model="data.supervisorName"  label="直接上级"/>

		<van-field v-if="!isDetail" readonly class="select" is-link clickable v-model="jobCodeName"  prop="jobCode" required name="职务" label="职务" placeholder="请输入职务名称搜索"
			@click="selectInfo('请输入职务名称搜索','level')" :rules="[{ required: true, message: '职务不能为空', trigger: 'onChange' }]"/>
		<van-field v-else disabled required v-model="data.jobDescr"  label="职务"/>

		<van-field  v-if="!isDetail" readonly v-model="data.seqRank" name="职级" prop="seqRank"  required label="职级" placeholder="职级由职务带出" disabled :rules="[{ required: true, message: '职级不能为空' }]"/>
		<van-field v-else disabled required v-model="data.seqRankDescr"  label="职级"/>

		<van-field v-if="!isDetail" readonly clickable required :disabled="isDetail" v-model="data.expEntryDate" prop="expEntryDate" label="入职时间" placeholder="请选择日期"
			@click="showCalendar = true" :rules="[{ required: true, message: '入职时间不能为空', trigger: 'onChange' }]"/>
		<van-field readonly  required v-else disabled v-model="data.expEntryDate"  label="入职时间"/>

		<van-field v-if="!isDetail" class="select" is-link readonly clickable  required v-model="locationName" label="工作地点" prop="location"  
		@click="selectInfo('请输入工作地点名称搜索','addr')" placeholder="请输入工作地点名称搜索" :rules="[{ required: true, message: '工作地点不能为空', trigger: 'onChange'}]"/>
		<van-field v-else disabled required v-model="data.locationDescr"  label="工作地点"/>

		<!-- 日历选择 弹层-->
		<van-calendar v-model="showCalendar" :show-confirm="false" :row-height="45" @confirm="onCalendar" />

		<!-- 搜索 弹层 -->
		<van-popup class="search-wrap" v-model="showSearch"  position="top">
			<form action="javascript:return true">
				<van-search v-model="queryVal" show-action :placeholder="placeholderVal" @cancel="onCancel" @search="onSearch" />
			</form>
			<van-list v-model="loadingList" :finished="finished" v-if="sign==='dept'">
				<van-cell v-for="item in lists" :key="item.deptLeaderId" :title="item.deptFullName+item.id" @click="confirmVal(item)" />
			</van-list>
			<van-list v-model="loadingList" :finished="finished" v-if="sign==='person'">
				<van-cell v-for="item in lists" :key="item.empId" :title="item.name+'/'+item.deptName" @click="confirmVal(item)" />
			</van-list>
			<van-list v-model="loadingList" :finished="finished" v-if="sign==='level'">
				<van-cell v-for="item in lists" :key="item.jobcode" :title="item.descr" @click="confirmVal(item)" />
			</van-list>
			<van-list v-model="loadingList" :finished="finished" v-if="sign==='addr'">
				<van-cell v-for="item in lists" :key="item.code" :title="item.name" @click="confirmVal(item)" />
			</van-list>
		</van-popup>

	</div>
</template>

<script>
import Vue from 'vue'
import { Notify } from 'vant'
Vue.use(Notify)
import moment from 'moment'
import {
	getOutsideJob, getAddress, getDeptList, getUsers, getSchedule,
	getSocialInfo,
} from '../network'

export default {
	name: 'mjobInfo',
	props: {
		isDetail:{
			type: Boolean,
		},
		data: {
            type: Object,
            required: true,
		},
		emplTypeTransCode: {
			type: String,
			default: '',
		},
		socailFlag: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			showCalendar: false,
			timeWord:'预计入职时间：',
			placeholderVal:'',
			queryVal: '', // 搜索关键词
			supervisorIdName: '',
			deptIdName: '',
			jobCodeName: '',
			locationName: '',
			personList:[],
			jobTypeList:[{
				jobcode: '', 
				descr: '',
				rank: '',
				rankCode: '', 
			}],
			addressList: [],
			disabledTime: [],
			deptinfoList:[],
			loadingList: false,
			finished: true,
			lists:[], // 搜索列表
			showSearch: false,
			sign: 'dept', // 标记 dept = 部门搜索；person=上级搜索；level=职务搜索; addr=地址搜索
		};
	},
	methods: {
		
		emitEvent(data){
			this.$emit('select',data)
		},
		// 取消搜索
		onCancel(){
			this.showSearch = false
			this.lists = []
			this.queryVal = ''
			this.finished = true
		},
		// 选择日期
		onCalendar(date){
			this.data.expEntryDate = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;
			this.showCalendar = false
			this.isGoDay(this.data.expEntryDate)
		},
		resetJob(){
			this.data.jobCode = ''
			this.data.seqRank = ''
			this.jobCodeName = ''
			this.jobTypeList = []
		},
		// 搜索弹出
		selectInfo(placeVal,sign){
			this.sign = sign
			if(sign==='level' && this.data.emplType === ''){
				Notify({ type: 'warning', message: '请先选择员工类型' })
				return
			}
			this.list = []
			this.showSearch = true
			this.finished = true
			this.placeholderVal = placeVal
		},
		//确认搜索
		onSearch(){
			if(this.sign === 'dept'){
				this.getDeptInfo(this.queryVal)
			}
			if(this.sign === 'person'){
				this.getPersonInfo(this.queryVal)
			}
			if(this.sign === 'level'){
				this.getOutsideJob(this.queryVal)
			}
			if(this.sign === 'addr'){
				this.getAddressList(this.queryVal)
			}
		},
		// 搜索确认值
		confirmVal(item){
			this.lists = []
			this.queryVal = ''
			this.showSearch = false
			if(this.sign === 'dept'){
				this.data.deptId = item.id
				this.deptIdName = item.name
				this.data.supervisorId = item.deptLeaderId
				this.supervisorIdName = item.deptLeaderName
			}
			if(this.sign === 'person'){
				this.supervisorIdName = item.name
				this.data.supervisorId = item.empId
			}
			if(this.sign === 'level'){
				this.data.jobCode = item.jobcode
				this.jobCodeName = item.name
				this.data.seqRank = item.rankCode
				if (this.socailFlag === 'Y') {
					let flag = item.jobcode && this.data.location
					this.getSocialInfo(flag)
				}
				this.emitEvent({code:'jobCode',val:item.jobcode || ''})
			}
			if(this.sign === 'addr'){
				this.data.location = item.code
				this.locationName = item.name
				if (this.socailFlag === 'Y') {
					let flag = item.code && this.data.jobCode
					this.getSocialInfo(flag)
				}
				this.emitEvent({code:'workLocation',val:item.code || ''})
			}
		},
		// 根据部门获取负责人
		getLeaderInfo(){
			this.deptinfoList.forEach((item)=>{
				if(this.data.deptId === item.id){
					this.personList = [{
						name: item.deptLeaderName,
						empId: item.deptLeaderId,
					}]
					this.data.supervisorId = item.deptLeaderId
					this.supervisorIdName = item.deptLeaderName
				}
			})
		},
		// 获取工作地点列表
		getAddressList(query) {
			if (query !== '') {
				setTimeout(() => {
					this.addressList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						name: query,
					}
					this.finished = false
					return getAddress(params).then((res)=>{
						this.finished = true
						let data = res.data
						if(data.code === 'S00000'){
							this.addressList = data.data.list
							this.lists = this.addressList || []
						} else {
							Notify({ type: 'danger', message: data.message })
						}
					}).catch((error)=>{
						this.finished =false
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.addressList = []	
			}
		},
		// 判断是否工作日
		isGoDay(dateVal){
			if(dateVal && dateVal !== ''){
				return getSchedule(dateVal).then((res)=>{
					let data = res.data
					if(data.code === 'S00000'){
						if(data.data.status === 'Y'){
							Notify({ type: 'warning', message: dateVal+'是非工作日，请选择工作日' })
							this.data.expEntryDate = ''
						}
					} else {
						Notify({ type: 'warning', message: data.message })
					}
				}).catch((error)=>{
					// this.$message.error(JSON.stringify(error))
				})
			}
		},
		// 搜索部门
		getDeptInfo(query) {
			if (query !== '') {
				setTimeout(() => {
					this.deptinfoList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					this.finished = false
					getDeptList(params).then((res)=>{
						let data =res.data
						if(data.code === 'S00000'){
							this.finished = true
							this.deptinfoList = data.data.list;
							this.deptinfoList.forEach((item)=>{
								if (this.$isQf) {
									if(item.deptFullName.match(/千峰合泰\/(\S*)/).length > 0){
										item.deptFullName = item.deptFullName.match(/千峰合泰\/(\S*)/)[1]
									}
								} else {
									if(item.deptFullName.match(/车好多集团\/(\S*)/).length > 0){
										item.deptFullName = item.deptFullName.match(/车好多集团\/(\S*)/)[1]
									}
								}
							})
							this.lists = this.deptinfoList || []
						} else {
							Notify({ type: 'warning', message: data.message });
						}
					}).catch((error)=>{
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.deptinfoList = []	
			}
		},
		//查人
		getPersonInfo(query){
			if (query !== '') {
				setTimeout(() => {
					this.personList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						queryName: query,
					}
					this.finished = false
					return getUsers(params).then((res)=>{
						this.finished = true
						let data =res.data
						if(data.code === 'S00000'){
							this.personList = data.data;
							this.lists = this.personList
						} else {
							Notify({ type: 'danger', message: data.message })
						}
					}).catch((error)=>{
						this.finished = true
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.personList = []	
			}
		},
		// 查询职务
		getOutsideJob(query){
			if(this.data && this.data.emplType === ''){
				Notify({ type: 'warning', message: '请选择员工类型' })
				return
			}
			if (query !== '') {
				setTimeout(() => {
					this.jobTypeList = [];
					let params = {
						pageNum: 1,
						pageSize: 30,
						name: query,
						emplType: this.data.emplType,
					}
					this.finished = false;
					return getOutsideJob(params).then((res)=>{
						this.finished = true
						let data =res.data
						if(data.code === 'S00000'){
							this.jobTypeList = data.data.list
							this.lists = this.jobTypeList || []
						} else {
							Notify({ type: 'danger', message: data.message })
						}
					}).catch((error)=>{
						this.finished = true
						// this.$message.error(JSON.stringify(error))
					})
				}, 200);
			} else{
				this.jobTypeList = []	
			}
			
		},
		// 根据职务信息查询社保
		async getSocialInfo(flag) {
			if (flag) {
				let { jobCode, location } = this.data
				let res = await getSocialInfo({
					jobCode,
					workLocation: location,
					emplType: this.emplTypeTransCode,
				}).catch()
				if (!res) return
				let { 
					socialInsuranceLocation, socialInsuranceLocationDescr,
					beRegularEmpPay, socialInsuranceBase,
					accidentInsurance, accidentInsuranceMedicine,
					houseAccFundBase, houseAccFundBaseMax,
					curDownLimit,
				} = res.data.data
				let accFoundMax = houseAccFundBaseMax
				houseAccFundBaseMax = this.socialBase(res.data.data)
				this.$set(this.data, 'socialInsuranceLocation', socialInsuranceLocation)
				this.$set(this.data, 'socialInsuranceLocationDescr', socialInsuranceLocationDescr)
				this.$set(this.data, 'beRegularEmpPay', beRegularEmpPay)
				this.$set(this.data, 'socialInsuranceBase', socialInsuranceBase)
				this.$set(this.data, 'accidentInsurance', accidentInsurance)
				this.$set(this.data, 'accidentInsuranceMedicine', accidentInsuranceMedicine)
				this.$set(this.data, 'houseAccFundBase', houseAccFundBase)
				this.$set(this.data, 'houseAccFundBaseMax', houseAccFundBaseMax)
				this.$set(this.data, 'accFoundMax', accFoundMax)
				this.$set(this.data, 'curDownLimit', curDownLimit)
			} else {
				this.$set(this.data, 'socialInsuranceLocation', '')
				this.$set(this.data, 'socialInsuranceLocationDescr', '')
				this.$set(this.data, 'beRegularEmpPay', '')
				this.$set(this.data, 'socialInsuranceBase', '')
				this.$set(this.data, 'accidentInsurance', '')
				this.$set(this.data, 'accidentInsuranceMedicine', '')
				this.$set(this.data, 'houseAccFundBase', '')
				this.$set(this.data, 'houseAccFundBaseMax', '')
				this.$set(this.data, 'accFoundMax', 0)
				this.$set(this.data, 'curDownLimit', 0)
			}
		},
		socialBase(data) {
            let { basePay, perfomPay } = this.data
            let { houseAccFundBaseMax, houseAccFundBase, curDownLimit } = data
			let result
			let sum = Number(basePay) + Number(perfomPay)
			if (isNaN(sum)) {
				sum = '0.00'
			} else {
				sum = (Math.round(sum * 100) / 100).toFixed(2)
			}
            if (houseAccFundBase === 'SAL' && houseAccFundBaseMax > sum) {
				result = sum
            } else if (houseAccFundBase === 'SAL') {
                result = houseAccFundBaseMax
            } else {
				result = curDownLimit
			}
            return result
        },
	},
}
</script>
<style lang="scss">
.search-wrap.van-popup.van-popup--top{
	height: 100%;
}
</style>
